/* global axios */
import ApiClient from './ApiClient';

class OrdersApi extends ApiClient {
  constructor() {
    super('orders', { accountScoped: true });
  }

  create({ conversationId, payload }) {
    // Legacy support for conversation orders
    const url = `${this.url.replace('/orders', '')}/conversations/${conversationId}/orders`;
    return axios.post(url, payload);
  }

  providerConfigs({ conversationId }) {
    const url = `${this.url.replace('/orders', '')}/conversations/${conversationId}/orders/provider_configs`;
    return axios.get(url);
  }

  get(inboxId, filters = {}) {
    return axios.get(this.url, {
      params: {
        ...filters,
        ...(inboxId ? { inbox_id: inboxId } : {}),
      },
    });
  }

  show(orderId) {
    return axios.get(`${this.url}/${orderId}`);
  }

  getByContact(contactId) {
    const url = `${this.url.replace('/orders', '')}/contacts/${contactId}/orders`;
    return axios.get(url);
  }
}

export default new OrdersApi();
